'use strict';

const asn1 = exports;

asn1.bignum = require('bn.js');

asn1.define = require('./asn1/api').define;
asn1.base = require('./asn1/base');
asn1.constants = require('./asn1/constants');
asn1.decoders = require('./asn1/decoders');
asn1.encoders = require('./asn1/encoders');



//////////////////
// WEBPACK FOOTER
// ./~/asn1.js/lib/asn1.js
// module id = 960
// module chunks = 2